import styles from "./Address.module.scss";
import { Form, Row, Col, Input, Select, Button } from "antd";
import { useTranslation } from "react-i18next";
import ReactInputMask from "react-input-mask";
import { convertPersian, validateInput } from "../../../../tools/tools";

import Steper from "../../../../components/steper/steper";
import SteperNewProfile from "../modules/steper";
import { useEffect, useState } from "react";
import { useAPIPublic, useTenders } from "../../../../tools/api";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import { useNavigate, useLocation } from "react-router-dom";
import { _adr } from "../../../../address";
import Loading from "../../../../components/loader/loading";
import Layouts, { useLayouts } from "../../../layout/layouts";
import { CheckToken } from "../../../../tools/services";
const Address = () => {
  const [t] = useTranslation("global");
  const [frmAddress] = Form.useForm();
  const { queryActiveProvince, queryCityByCityId, queryActiveCityByProvinceId } = useAPIPublic();
  const { addressByPostcode, addAddress } = useTenders();
  const dispatch = useDispatch();
  const formData = useSelector((state) => state?.from?.newUser);

  console.log(formData);

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const location = useLocation();

  const nav = useNavigate();

  const [loading, setLoading] = useState(false);

  const { refreshUser, checkLoginUser } = useLayouts();

  //check Login
  const [isLogin, setLogin] = useState();

  //user Info
  const [user, setUser] = useState({});

  useEffect(() => {
    const checkLogin = async () => {
      const isCheck = await checkLoginUser();
      if (isCheck) {
        const userInfo = await refreshUser();
        setUser(userInfo || {});
        if (formData?.hasCompleted && !formData?.hasCompleted) {
          setLogin(false);
        } else {
          setLogin(isCheck);
        }
      }
    };
    checkLogin();
  }, [checkLoginUser, refreshUser]);

  useEffect(() => {
    if (formData?.profile) {
      handleCityListByProvinceId(formData?.profile?.provinceid);
      frmAddress.setFieldsValue({
        cityid: formData?.profile?.cityid,
        provinceid: formData?.profile?.provinceid,
        postalcode: formData?.profile?.postalcode,
        mainstreet: formData?.profile?.mainStreet,
        buildingno: formData?.profile?.buildingNo,
        floor: formData?.profile?.floor,
        alley: formData?.profile?.alley,
        auxiliaryroad: formData?.profile?.auxiliaryRoad,
        tel: formData?.profile?.tel,
        unit: formData?.profile?.unit,
      });
      setPostalCodeServ((prev) => ({
        ...prev,
        postCode: formData?.profile?.postalcode,
      }));
    }
  }, [formData]);

  //state postalCode ID
  const [postalCodeServ, setPostalCodeServ] = useState({
    postCode: "",
    prevCode: "",
  });

  useEffect(() => {
    if (location?.state?.type === "edit") {
      setPostalCodeServ({
        postCode: location.state.type === "edit" ? postalCodeServ?.postCode || "" : "",
        prevCode: location.state.type === "edit" ? postalCodeServ?.postCode || "" : "",
      });
    }
  }, []);
  //Call Service Read Postalcode From Service
  useEffect(() => {
    const CallPostalCode = async () => {
      try {
        if (postalCodeServ.postCode.length === 10 && postalCodeServ.postCode !== postalCodeServ.prevCode) {
          let payload = {
            postCode: frmAddress.getFieldValue("postalcode"),
          };
          setLoading(true);
          let resPost = await addressByPostcode(payload);
          if (resPost) {
            setPostalCodeServ((prev) => ({
              ...prev,
              prevCode: postalCodeServ.postCode,
            }));
            frmAddress.setFieldsValue({
              mainstreet: resPost?.mainStreet,
              buildingno: resPost?.buildingNo,
              floor: resPost?.floor,
              alley: resPost?.alley,
              auxiliaryroad: resPost?.auxiliaryRoad,
              tel: resPost?.tel,
            });
            if (resPost?.cityId) {
              let resProvince = await queryCityByCityId(resPost?.cityId);
              if (resProvince) {
                frmAddress.setFieldsValue({
                  provinceid: resProvince?.provinceid,
                });
                handleCityListByProvinceId(resProvince?.provinceid);
              }
            }
          }
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    // CallPostalCode();
  }, [postalCodeServ.postCode]);
  //#endregion Get Address From Service Post ===========

  const [initialData, setInitialData] = useState({
    province: [],
    city: [],
  });
  useEffect(() => {
    const callServInitial = async () => {
      //Call Service Gender
      if (initialData.province.length === 0) {
        //Call Service Province
        let resProvince = await queryActiveProvince();
        if (resProvince) {
          setInitialData((prev) => ({ ...prev, province: resProvince }));
        }
      }
    };
    callServInitial();
  }, []);

  //#region Call Service get all Cities From Province
  const handleCityListByProvinceId = async (item) => {
    let resCity = await queryActiveCityByProvinceId(item);
    if (resCity) {
      setInitialData((prev) => ({ ...prev, city: resCity }));
    }
  };
  //#endregion Call Service get all Cities From Province

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        profileid: formData.profile.profileid,
        addresstype: 0,
        addressmodel: {
          cityid: values.cityid,
          mainstreet: values.mainstreet,
          auxiliaryroad: values.auxiliaryroad,
          alley: values.alley,
          buildingno: values.buildingno,
          floor: values.floor,
          postalcode: values.postalcode,
          tel: values.tel,
          unit: values.unit,
        },
      };
      let resAddress = await addAddress(payload);
      if (!resAddress?.HasError) {
        payload.addresstype = 1;
        let resAgainAddress = await addAddress(payload);
        if (!resAgainAddress?.HasError) {
          let txtProvince = initialData?.province.find((item) => item.inT__ProvinceId === frmAddress.getFieldValue("provinceid"))?.stR_ProvinceName;
          let txtCity = initialData?.city.find((item) => item.inT_CityId === frmAddress.getFieldValue("cityid"))?.stR_CityName;
          if (!isLogin) {
            dispatch(
              simcardPurchase({
                newUser: {
                  profile: {
                    ...formData?.profile,
                    ...values,
                    txtProvince: txtProvince,
                    txtCity: txtCity,
                  },
                  hasCompleted: false,
                },
              }),
            );
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.BankInfo);
          } else {
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      <SteperNewProfile current={1} />

      <div className={styles.address}>
        <div className="page_title">
          <h3>اطلاعات تماس </h3>
        </div>
        <Form id="frmAddress" className={styles.holdForm} form={frmAddress} onFinish={handleSubmit} layout="vertical">
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="tel" label="تلفن ثابت" rules={[validateInput({ t: t, validate: true, type: "number" })]}>
                <Input inputMode="numeric" dir="ltr" autoComplete="off" maxLength={11} />
              </Form.Item>
            </Col>
          </Row>
          <div className="page_title">
            <h3>اطلاعات آدرس </h3>
          </div>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="postalcode" label="کدپستی" rules={[validateInput({ t: t, validate: true, type: "number" })]}>
                <Input
                  onBlur={(e) => {
                    setPostalCodeServ((prev) => ({
                      ...prev,
                      postCode: e.target.value,
                    }));
                  }}
                  onChange={(e) => (e.target.value = convertPersian(e.target.value))}
                  inputMode="numeric"
                  autoComplete="off"
                  dir="ltr"
                  maxLength={10}
                />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="provinceid" label="استان" rules={[validateInput({ t: t, validate: true })]}>
                <Select
                  filterOption={(inputValue, option) => {
                    return option.children.toString().includes(inputValue.toString());
                  }}
                  onChange={(item, option) => {
                    handleCityListByProvinceId(item);
                  }}
                >
                  {initialData.province.map((item) => (
                    <Select.Option key={item.inT__ProvinceId} value={item.inT__ProvinceId}>
                      {item.stR_ProvinceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="cityid" label="شهر" rules={[validateInput({ t: t, validate: true })]}>
                <Select
                  filterOption={(inputValue, option) => {
                    return option.children.toString().includes(inputValue.toString());
                  }}
                >
                  {initialData?.city.map((item, key) => (
                    <Select.Option key={key} value={item.inT_CityId}>
                      {item.stR_CityName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="mainstreet"
                label="خیابان اصلی"
                rules={[
                  validateInput({
                    t: t,
                    validate: true,
                    type: "persian",
                  }),
                ]}
              >
                <Input placeholder="خیابان اصلی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="alley"
                label="کوچه"
                rules={[
                  validateInput({
                    t: t,
                    validate: true,
                    type: "persian",
                  }),
                ]}
              >
                <Input placeholder="کوچه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="auxiliaryroad"
                label="خیابان فرعی"
                rules={[
                  validateInput({
                    t: t,
                    validate: true,
                    type: "persian",
                  }),
                ]}
              >
                <Input placeholder="خیابان فرعی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="buildingno"
                label="پلاک"
                rules={[
                  validateInput({
                    t: t,
                    validate: true,
                    type: "number",
                  }),
                ]}
              >
                <Input placeholder="پلاک" onChange={(e) => (e.target.value = convertPersian(e.target.value))} inputMode="numeric" />
              </Form.Item>
            </Col>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="floor" label="طبقه" rules={[validateInput({ t: t, validate: true, type: "number" })]}>
                <Input placeholder="طبقه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={30}>
            <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
              <Form.Item name="unit" label="واحد" rules={[validateInput({ t: t, validate: true, type: "number" })]}>
                <Input placeholder="واحد" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {isLogin ? (
          <>
            <div className="holder-button">
              <Button form="frmAddress" key={frmAddress} htmlType="submit" className="btn-aptel">
                ویرایش
              </Button>
              <Button onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review)}>
                انصراف
              </Button>
            </div>
          </>
        ) : (
          <div className="holder-button">
            <Button form="frmAddress" key={frmAddress} htmlType="submit" className="btn-normal btn-aptel">
              مرحله بعد
            </Button>
            <Button
              onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Profile)}
              className="btn-normal"
            >
              بازگشت
            </Button>
          </div>
        )}
      </div>
      <Loading isOpen={loading} />
    </>
  );
};

export default Address;
